/** @format */

export function AppRun($gbRealtime, $gbAuction, $gbItem, $gbInfobooth, $gbItemActivity, $gbTeamScoringProjectorWidget) {
    'ngInject';

    $gbRealtime.watchSyncEvent($gbAuction.realtimeSyncEvent);
    $gbRealtime.watchSyncEvent($gbItem.realtimeSyncEvent);
    $gbRealtime.watchSyncEvent($gbInfobooth.realtimeSyncEvent);
    $gbRealtime.watchSyncEvent($gbTeamScoringProjectorWidget.realtimeSyncEvent);
    $gbRealtime.watchSyncEvent($gbItemActivity.realtimeSyncEvent, $gbItemActivity.realtimeSyncDoneEvent);
}
